import { FilterHandlerBase } from './base/filter-handler-base';
import {
  AdvancedFilterName,
  FilterOptions,
  FilterPassParams,
  InclusiveExclusiveFilterModel
} from '../filter-types';
import { SyndicateMember, SyndicateRole } from '../../../types/deal.types';
import { FilterResultFacade } from '../filter-result-facade';
import { OptionsType } from '../../issue/maturity';

export class SyndicateAdvancedFilterHandler extends FilterHandlerBase {
  get name(): string {
    return AdvancedFilterName.syndicate;
  }

  get isInclusiveExclusive(): boolean {
    return true;
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return filterOptions.syndicates.map(
      (member: SyndicateMember) => member.shortName || member.departmentName
    );
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const syndicate = params.filters[this.name];
    const data = params.deal;
    const filterOptions = params.options;

    let isSyndicateFilterPassed = true;
    if (syndicate && syndicate.model) {
      const syndicateFilterModel = syndicate.model as InclusiveExclusiveFilterModel;

      const filterBlank = syndicateFilterModel.storeValues
        ? syndicateFilterModel.storeValues.indexOf(OptionsType.Blank) !== -1
        : false;

      const members: SyndicateMember[] = (
        syndicateFilterModel.storeValues || []
      )
        .map((value: string) => {
          const syndicateMemberList = filterOptions
            ? filterOptions.syndicates.filter(
                (member: SyndicateMember) =>
                  member.shortName === value || member.departmentName === value
              )
            : [];
          return !syndicateMemberList ? null : syndicateMemberList[0];
        })
        .filter((value) => value !== null);

      let hasFilterValue = data.syndicate.some(
        (value: SyndicateMember): boolean => {
          return (
            members.filter((member) => {
              if (member) {
                return member.shortName
                  ? member.shortName === value.shortName &&
                      (value.role === SyndicateRole.seniorManager ||
                        value.role === SyndicateRole.coSenior ||
                        value.role === SyndicateRole.coManager)
                  : member.departmentName === value.departmentName &&
                      (value.role === SyndicateRole.seniorManager ||
                        value.role === SyndicateRole.coSenior ||
                        value.role === SyndicateRole.coManager);
              } else {
                return undefined;
              }
            }).length > 0
          );
        }
      );

      hasFilterValue = filterBlank
        ? data.syndicate.length === 0 || hasFilterValue
        : hasFilterValue;

      isSyndicateFilterPassed = syndicateFilterModel.isInclusive
        ? hasFilterValue
        : !hasFilterValue;
    }
    result.applyDealFilerResult(data.id, this.name, isSyndicateFilterPassed);

    return isSyndicateFilterPassed;
  }
}
